var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-card" }, [
    _vm._m(0),
    _c(
      "section",
      { staticClass: "modal-card-body" },
      [
        _c("p", { staticClass: "has-text-danger has-text-weight-bold" }, [
          _vm._v("פעולה זו אינה הפיכה! הדוח יימחק לצמיתות.")
        ]),
        _c("p", { staticClass: "mt-2" }, [
          _vm._v(" לאישור המחיקה, יש להזין את מספר הדוח: "),
          _c("strong", [_vm._v(_vm._s(_vm.reportNumber))])
        ]),
        _c(
          "b-field",
          { staticClass: "mt-4", attrs: { label: "מספר דוח לאישור" } },
          [
            _c("b-input", {
              attrs: { placeholder: "הזן מספר דוח" },
              model: {
                value: _vm.confirmationInput,
                callback: function($$v) {
                  _vm.confirmationInput = $$v
                },
                expression: "confirmationInput"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "footer",
      { staticClass: "modal-card-foot" },
      [
        _c(
          "b-button",
          {
            attrs: {
              type: "is-danger",
              disabled:
                _vm.confirmationInput !== String(_vm.reportNumber) ||
                _vm.isLoading,
              loading: _vm.isLoading
            },
            on: { click: _vm.onDelete }
          },
          [_vm._v("מחק דוח")]
        ),
        _c(
          "b-button",
          {
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_vm._v("בטל")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [_vm._v("מחיקת דוח")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }